
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-e144535a!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DataAnalysis.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./DataAnalysis.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-e144535a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./DataAnalysis.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/center/DataAnalysis.vue
// module id = 571
// module chunks = 0